import clsx from "clsx";
import React, { FC } from "react";
import { useTimeTracker } from "utils/hooks/useTimeTracker";
import { TimeTrackerStatusIcon } from "./TimeTrackerStatusIcon";

const TimerDisplay: FC<{
  className?: string;
  iconSize?: number;
  onClick?: () => void;
}> = ({ className, iconSize = 24, onClick }) => {
  // Hooks
  const { isRunning, formattedTime } = useTimeTracker();

  return (
    <button
      className={clsx(
        "border border-gray-100 px-2.5 py-[5px] flex items-center gap-1 bg-white rounded min-w-[100px]",
        className,
      )}
      onClick={onClick}
    >
      <TimeTrackerStatusIcon size={iconSize} isActive={isRunning} />
      {formattedTime}
    </button>
  );
};

export default TimerDisplay;
